import { RootState } from "../../../store";
import { resourceExplorerGranularViewResponseSelector } from "../current-resource-explorer/data-grid/granular-costs-view/resourceExplorerGranularViewResponseSelector";

export const resourceExplorerGranularDataLoadingSelector = (
  state: RootState,
) => {
  return !!resourceExplorerGranularViewResponseSelector(state)?.isLoading;
};
